/**
 * 路由控制
 */
const win = window;

const hashObj = {
    /**
     * [init 初始化，根据路由的hash定位到相应页面]
     * @param  {[type]} store [vuex]
     * @param  {[type]} route [添加到vue-route的数组]
     */
    init (store, route) {
        let hash = win.location.hash.replace(/#/, ''),
            isMatchHash = false; // 是否有匹配到路由

        if (hash !== '/') {
            // 跳转到相应路由
            route.forEach(function (item) {
                item.children.forEach(function (node, index) {
                    if (node.path === hash) {
                        store.commit('AddTab', {
                            id: node.id,
                            comp: node.comp,
                            component: node.component,
                            name: node.name,
                            path: node.path,
                            memberId: ''
                        });

                        isMatchHash = true;
                    }
                });
            });

            if (isMatchHash === false) {
                hashObj.openDefaultPage(store, route);
            }
        } else { // 默认打开第一个页面
            hashObj.openDefaultPage(store, route);
        }
    },

    /**
     * [openDefaultPage 默认打开第一个页面]
     */
    openDefaultPage (store, route) {
        let node = route[0].children[0];

        if (node) {
            store.commit('AddTab', {
                comp: node.comp,
                component: node.component,
                name: node.name,
                path: node.path,
                memberId: ''
            });
        }

    },

    /**
     * [change 改变路由的hash值]
     * @param  {[type]} hash [改变的值]
     * @param  {[bool]} unHash [是否要改变hash]
     */
    change (hash, unHash) {
        if (!unHash) {
            win.location.hash = hash;
        }
    }
};



export default hashObj;


// WEBPACK FOOTER //
// ./src/router/hash.js